<template>
  <div class="component-filter">
    <el-form inline :label-width="labelWidth" :label-position="labelPosition?labelPosition:'right'" @submit.native.prevent class="component-filter-left hd" ref="box" :style="{width: width ? width + 'px' : 'calc(100% - 20px)',minWidth: width ? width + 'px' : '0px'}">
      <slot></slot>
      <el-form-item>
        <el-button type="primary" @click="clickSubmit"  size="mini">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button v-if="!notReset" @click="clickReset" autofocus type="primary" size="mini">重置</el-button>
      </el-form-item>
      <el-form-item v-if="pageName === 'stat'">
        <el-button @click="clickExport" type="primary" size="mini" >导出</el-button>
      </el-form-item>
      <slot name="customAction"></slot>
    </el-form>


  </div>
</template>
<style lang="scss">
  @import "filter.theme";

  .component-filter {
    display: flex;
    align-items: center;
    .component-filter-left {
      box-sizing: border-box;
      margin-bottom: -$filter-item-margin-bottom;
      .el-form-item {
        margin-bottom: $filter-item-margin-bottom;
        margin-right: 10px;
      }
      .el-form-item__label,.el-form-item__content{
        line-height:30px;
      }
      .el-input {
        width: $filter-input-width;
      }
      > div.el-form-group {
        display: flex;
        justify-content: space-around;
        .el-form-item {
          margin-right: 2px;
        }
      }
    }
    .component-filter-right {
      width: 210px;
      height: 40px;
      padding: 6px 0;
      box-sizing: border-box;
    }
    .component-filter-wrap{
      flex: 1;
      text-align: right;
    }
    .t-filter-item-2 {
      border-bottom: 1px solid rgba(77, 167, 231, 0.5);
      line-height: 32px;
      margin-top: 3px;
      .el-input__inner {
        border: none;
      }
    }
    .t-filter-item-2:hover {
      border-bottom: 1px solid #fff;
    }
    .el-input__inner{
        padding:0 30px 0 5px;
    }
    .el-form-item__label{
      padding-right:3px;
    }
  }
  .component-title .title {
    font-size: 14px;
  }
</style>

<!--☯js-->
<script>
  import * as eventJs from '../../../../../../src/base-components/filter/event.js'
  const {event, life, watch} = eventJs.default ? eventJs.default : eventJs
  import * as modelJS from '../../../../../../src/base-components/filter/model.js'
  const model = modelJS.default ? modelJS.default : modelJS
  import * as methodsJs from '../../../../../../src/base-components/filter/methods.js'
  const methodsSource = methodsJs.default ? methodsJs.default : methodsJs
  import vmConfig from '../../../../core/vmConfigHandler.js'
  // 异步加载某些情况下会出问题，原因未知，所以暂时不采用异步加载
  // r => require.ensure([], () => r(require('%path')), 'c-base-filter')
  export default {
    name: 'base-filter', // o not use built-in or reserved HTML elements as component id:img, 意思是不能和html标签同名，那么加个下划线好了
    components: {
      /*import components file template:'base-filter': require('%path').default,
       */
      /*start:import components file*/
/*end:import components file*/
    },
    ...vmConfig(model, life, event, watch, methodsSource)
  }
</script>